import { BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine, Cell } from "recharts";

const tip = { contentStyle: { background: "#050505", border: "1px solid #262626", borderRadius: 0, fontFamily: "JetBrains Mono", fontSize: 12, color: "#fff" }, labelStyle: { color: "#A3A3A3" }, cursor: { fill: "#F5F5F5" } };
const axis = { tick: { fontFamily: "JetBrains Mono", fontSize: 10, fill: "#525252" }, axisLine: { stroke: "#E5E5E5" }, tickLine: false };

export default function UsageCharts({ usage }) {
  const daily = usage.daily.slice(-30).map((d) => ({ ...d, label: d.date.slice(5) }));
  const avg = usage.avg_daily_kwh;
  const peakHour = usage.hourly.reduce((m, h) => (h.kw > m.kw ? h : m), usage.hourly[0]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-px bg-kl-lineLight border border-kl-lineLight" data-testid="usage-charts">
      <div className="lg:col-span-3 bg-white p-5">
        <div className="flex items-baseline justify-between mb-4">
          <div><p className="kl-label">Daily consumption</p><h3 className="font-display text-lg mt-0.5">Last {daily.length} days</h3></div>
          <span className="font-mono text-xs text-kl-mutedLight">avg {avg} kWh</span>
        </div>
        <ResponsiveContainer width="100%" height={220}>
          <BarChart data={daily} barCategoryGap={3}>
            <XAxis dataKey="label" {...axis} interval={4} />
            <YAxis {...axis} width={34} />
            <Tooltip {...tip} formatter={(v) => [`${v} kWh`, "energy"]} />
            <ReferenceLine y={avg} stroke="#00C853" strokeDasharray="3 3" />
            <Bar dataKey="kwh" isAnimationActive={false} maxBarSize={28}>
              {daily.map((d, i) => <Cell key={i} fill={d.kwh >= avg * 1.15 ? "#00E676" : "#050505"} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="lg:col-span-2 bg-kl-black text-white p-5">
        <div className="flex items-baseline justify-between mb-4">
          <div><p className="kl-label-dark">Hourly load profile</p><h3 className="font-display text-lg mt-0.5">Avg kW by hour</h3></div>
          <span className="font-mono text-xs text-kl-green">peak {String(peakHour.hour).padStart(2, "0")}:00</span>
        </div>
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={usage.hourly}>
            <XAxis dataKey="hour" tick={{ ...axis.tick, fill: "#A3A3A3" }} axisLine={{ stroke: "#262626" }} tickLine={false} interval={3} tickFormatter={(h) => `${String(h).padStart(2, "0")}`} />
            <YAxis tick={{ ...axis.tick, fill: "#A3A3A3" }} axisLine={false} tickLine={false} width={34} />
            <Tooltip {...tip} cursor={{ stroke: "#262626" }} labelFormatter={(h) => `${String(h).padStart(2, "0")}:00`} formatter={(v) => [`${v} kW`, "load"]} />
            <ReferenceLine x={peakHour.hour} stroke="#00E676" strokeDasharray="2 4" />
            <Line type="stepAfter" dataKey="kw" stroke="#FFFFFF" strokeWidth={2} dot={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
